import { CssBaseline } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuIcon from "@material-ui/icons/Menu";
import { Transformation } from "cloudinary-react";
import Image from "cloudinary-react/lib/components/Image/Image";
import React from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { withRouter } from "react-router";
import { createStructuredSelector } from "reselect";
import { selectGemeinde } from "../../redux/gemeinde/gemeinde.selector";
import { signOutStart } from "../../redux/user/user.actions";
import { selectCurrentUser } from "../../redux/user/user.selector";
//import "./header.styles.scss";

const drawerWidth = 200;

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
    color: "#000",
  },

  user: {
    display: "flex",
    alignItems: "center",
    color: "#000",
  },
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: {
    ...theme.mixins.toolbar,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient( 90deg, rgb(255,255,255), rgb(236,255,200) );",
  },
  drawerPaper: {
    width: drawerWidth,
    background: "linear-gradient( 90deg, rgb(255,255,255), rgb(236,255,200) );",
  },
  subtitle: {},
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  logo: {
    padding: "7px 5px 3px 5px",
  },
}));

const Header = withRouter(
  ({ currentUser, signOutStart, gemeinde, window, history }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };
    const handleDrawerClose = () => {
      setMobileOpen(false);
    };
    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const drawer = (
      <div>
        <div className={classes.toolbar}>
          <RouterLink to="/">
            <Image className={classes.logo} publicId="dersaemann_t3xkit.png">
              <Transformation
                quality="auto"
                radius="20"
                width="100"
                height="120"
                crop="fill"
              />
            </Image>
          </RouterLink>
        </div>
        <List>
          <ListItem
            button
            key="berichte"
            component={RouterLink}
            to="/berichte"
            onClick={handleDrawerClose}
          >
            <Typography variant="h6">Berichte</Typography>
          </ListItem>
          {gemeinde && (
            <ListItem
              button
              key="gemeinde"
              component={RouterLink}
              to="/gemeinde"
              onClick={handleDrawerClose}
            >
              <Typography variant="h6">Meine Gemeinde</Typography>
            </ListItem>
          )}
          {gemeinde && (
            <ListItem
              button
              key="kornspeicher"
              component={RouterLink}
              to="/kornspeicher"
              onClick={handleDrawerClose}
            >
              <Typography variant="h6">Kornspeicher</Typography>
            </ListItem>
          )}
          <ListItem
            button
            key="rangliste"
            component={RouterLink}
            to="/rangliste"
            onClick={handleDrawerClose}
          >
            <Typography variant="h6">Rangliste</Typography>
          </ListItem>
          <ListItem
            button
            key="regeln"
            component={RouterLink}
            to="/regeln"
            onClick={handleDrawerClose}
          >
            <Typography variant="h6">Regeln</Typography>
          </ListItem>
          <ListItem
            button
            key="faqs"
            component={RouterLink}
            to="/faq"
            onClick={handleDrawerClose}
          >
            <Typography variant="h6">FAQs</Typography>
          </ListItem>
          {/*<ListItem button key="test">
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary="test" />
        </ListItem> */}
        </List>
      </div>
    );
    const container =
      window !== undefined ? () => window().document.body : undefined;
    return (
      <div>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={classes.appBar}
          style={{ background: theme.palette.primary.mainGradient }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.title}>
              <Typography variant="h4" className={classes.title}>
                Ideen säen
              </Typography>
              <Typography variant="subtitle2" className={classes.subtile}>
                Das große Kreativspiel des Dekanats Wetterau-West
              </Typography>
            </div>
            {currentUser ? (
              <div className={classes.user}>
                <Typography variant="subtitle1">
                  {currentUser.displayName}
                </Typography>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem
                    component={RouterLink}
                    to="/gemeinde"
                    onClick={handleClose}
                  >
                    Meine Gemeinde
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      signOutStart(() => history.replace("/"));
                    }}
                  >
                    Abmelden
                  </MenuItem>
                </Menu>
              </div>
            ) : (
              <Button component={RouterLink} to="/signin">
                Anmelden
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <nav className={classes.drawer} aria-label="folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
      </div>
    );
  }
);
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  gemeinde: selectGemeinde,
});
const mapDispatchToProps = (dispatch) => ({
  signOutStart: (callback) => dispatch(signOutStart(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
